module.exports = __webpack_public_path__ + "img/multi_unit_1.6e0eab17.png";